/**
 * A mixin that adds event emitting capabilities to a class
 * @param {typeof HTMLElement} superClass - The class to extend
 * @returns {typeof HTMLElement} A class with event emitting capabilities
 */
export function EventEmitterMixin(superClass) {
  class EventEmitterElement extends superClass {
    /**
     * Adds an event listener to the element
     * @param {string} type - The event type to listen for
     * @param {EventListenerOrEventListenerObject} listener - The callback function
     * @param {boolean | AddEventListenerOptions} [options] - Event listener options
     */
    addEventListener(type, listener, options) {
      super.addEventListener(type, listener, options);
    }

    /**
     * Removes an event listener from the element
     * @param {string} type - The event type to remove
     * @param {EventListenerOrEventListenerObject} listener - The callback function to remove
     * @param {boolean | EventListenerOptions} [options] - Event listener options
     */
    removeEventListener(type, listener, options) {
      super.removeEventListener(type, listener, options);
    }

    /**
     * Emits a custom event from the element
     * @param {string} type - The event type to emit
     * @param {CustomEventInit} [eventInitDict] - Custom event initialization options
     * @returns {boolean} Returns false if event is cancelable and at least one handler called preventDefault
     */
    emitEvent(type, eventInitDict) {
      return this.dispatchEvent(
        new CustomEvent(type, {
          bubbles: true,
          cancelable: false,
          composed: true,
          detail: undefined,
          ...eventInitDict,
        })
      );
    }
  }
  return EventEmitterElement;
}
